/**
 * Firebase Configuration
 *
 * Firebase initialization and configuration for the application
 * Used for authentication and Firestore database operations
 */

import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);

// Connect to Firebase emulators for local development
// Only when explicitly opted-in via VITE_USE_FIREBASE_EMULATOR=true
// This allows using the real Firebase auth (dev project) with a local backend
const shouldUseEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true';

if (shouldUseEmulator) {
  try {
    connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
    connectFirestoreEmulator(db, 'localhost', 8080);
    // Emulators connected successfully
  } catch (_error) {
    // Emulators might already be connected, ignore this error
  }
}

export { app };
